import { FilterState } from '../../../../containers/applicant_tracking/Analytics/Filters';
import { Funnel } from '../../../../entities/applicant_tracking/analytics/Funnel';
import { ApiService } from '../../../ApiService';
import { mapToParams } from '../mapToParams';

export class FunnelService {
  public static show(
    filterState?: FilterState,
    signal?: AbortSignal,
  ): Promise<Funnel> {
    return ApiService.get(
      '/api/v1/applicant_tracking/analytics/funnel',
      mapToParams(filterState),
      { signal },
    );
  }
}
